import { useAppContext } from '@provider/app-context';
import { GyldendalLogoSmall, GyldendalLogoLarge } from './Gyldendal.js';
import { HansReitzelLogoSmall, HansReitzelLogoLarge } from './HansReitzel.js';
import { MunksgaardLogoSmall, MunksgaardLogoLarge } from './Munksgaard.js';
import { SystimeLogoSmall, SystimeLogoLarge } from './Systime.js';
import { jsx } from 'react/jsx-runtime';

const PublisherLogo = ({
  small,
  className,
  color = "currentColor",
  preserveAspectRatio
}) => {
  const publisher = useAppContext(state => state.publisher);
  if (small) {
    switch (publisher) {
      case "hans-reitzel":
        return /*#__PURE__*/jsx(HansReitzelLogoSmall, {
          color: color,
          className: className,
          preserveAspectRatio: preserveAspectRatio
        });
      case "munksgaard":
        return /*#__PURE__*/jsx(MunksgaardLogoSmall, {
          color: color,
          className: className,
          preserveAspectRatio: preserveAspectRatio
        });
      case "systime":
        return /*#__PURE__*/jsx(SystimeLogoSmall, {
          color: color,
          className: className,
          preserveAspectRatio: preserveAspectRatio
        });
      case "louisiana":
        console.warn("<PublisherLogo />: no logo has been configured for Publisher.LOUISIANA");
        return null;
      default:
        return /*#__PURE__*/jsx(GyldendalLogoSmall, {
          color: color,
          className: className,
          preserveAspectRatio: preserveAspectRatio
        });
    }
  }
  switch (publisher) {
    case "hans-reitzel":
      return /*#__PURE__*/jsx(HansReitzelLogoLarge, {
        color: color,
        className: className,
        preserveAspectRatio: preserveAspectRatio
      });
    case "munksgaard":
      return /*#__PURE__*/jsx(MunksgaardLogoLarge, {
        color: color,
        className: className,
        preserveAspectRatio: preserveAspectRatio
      });
    case "systime":
      return /*#__PURE__*/jsx(SystimeLogoLarge, {
        color: color,
        className: className,
        preserveAspectRatio: preserveAspectRatio
      });
    case "louisiana":
      console.warn("<PublisherLogo />: no logo has been configured for Publisher.LOUISIANA");
      return null;
    default:
      return /*#__PURE__*/jsx(GyldendalLogoLarge, {
        color: color,
        className: className,
        preserveAspectRatio: preserveAspectRatio
      });
  }
};

export { GyldendalLogoLarge, GyldendalLogoSmall, HansReitzelLogoLarge, HansReitzelLogoSmall, MunksgaardLogoLarge, MunksgaardLogoSmall, PublisherLogo, SystimeLogoLarge, SystimeLogoSmall };
//# sourceMappingURL=index.js.map
